import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for fetching business data
export const fetchBusinessData = createAsyncThunk(
  'business/fetchBusinessData',
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.get('https://onboard.rechargkit.biz/member/business', {
        headers: {
        'Authorization': `Bearer ${token}`,
        },
      });
      console.log("✅ API Response from /member/business:", response.data.business);
      return response.data.business;
       
    } catch (error) {
      console.error(" Error in fetchBusinessData:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || 'An error occurred while fetching business data');
    }
  }
);

  const businessSlice = createSlice({
  name: 'businesstrack',
    initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
       .addCase(fetchBusinessData.pending, (state) => {
        state.loading = true;
        state.error = null;
       })
      .addCase(fetchBusinessData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
       })
      .addCase(fetchBusinessData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default businessSlice.reducer;
